import { GlobalCardBody } from '@global-engineering-shared/gweb-material-lab';
import React, { useEffect } from 'react';

import { Dates } from 'context/DateProvider/DateProvider';
import StatusHistoryChart from 'features/Status/components/StatusHistory/StatusHistoryChart/StatusHistoryChart';
import useStyles from 'features/Status/containers/StatusHistoryChartContainer/StatusHistoryChartContainer.styles';
import { StatusData } from 'features/Status/types/statusData';
import { CUSTOM_BLUE } from 'utils/colours';

type StatusHistoryChartContainerProps = {
  frameId: string;
  minDateTimeRange: string;
  maxDateTimeRange: string;
  dateTimeRange: Dates;
  setDateTimeRange: React.Dispatch<React.SetStateAction<Dates>>;
  statuses: StatusData[];
};

const StatusHistoryChartContainer = ({
  frameId,
  minDateTimeRange,
  maxDateTimeRange,
  dateTimeRange,
  setDateTimeRange,
  statuses,
}: StatusHistoryChartContainerProps) => {
  const classes = useStyles();

  useEffect(() => {}, [frameId, statuses, dateTimeRange, minDateTimeRange, maxDateTimeRange]);

  return (
    <>
      <GlobalCardBody className={classes.body}>
        <StatusHistoryChart
          chartId={`status-history-chart-${frameId}`}
          chartData={statuses.sort((a, b) => (a.time > b.time ? 1 : -1))}
          minDateTimeRange={minDateTimeRange}
          maxDateTimeRange={maxDateTimeRange}
          lineColor={CUSTOM_BLUE}
          dateTimeRange={dateTimeRange}
          setDateTimeRange={setDateTimeRange}
        />
      </GlobalCardBody>
    </>
  );
};

export default StatusHistoryChartContainer;
